// extracted by mini-css-extract-plugin
module.exports = {"wrap":"nav_wrap__3uudF","logo":"nav_logo__1u3_b","user":"nav_user__3LUOl"};